import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  checkQuestionsComplete,
  fetchMyinfo,
} from "../../../../features/mobile/otherSlice";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import HeadCont from "../../components/common/HeadCont";
import TitleBox from "../../components/common/TitleBox";
import NutritionCard from "../../components/healthInfo/NutritionCard";
import CautionFood from "../../components/healthInfo/CautionFoodCard";
import BodyInfoCard from "../../components/healthInfo/BodyInfoCard";
import FoodLifeCard from "../../components/healthInfo/FoodLifeCard";
import MenuBar from "../../components/common/MenuBar";
import BodyMassCard from "../../components/healthInfo/BodyMassCard";
import AnimateCard from "../../components/common/AnimateCard";
import useGAEvent from "../../hooks/useGAEvent";
const objFalse = {
  0: false,
  1: false,
  2: false,
  3: false,
  4: false,
};
const objTrue = {
  0: true,
  1: true,
  2: true,
  3: true,
  4: true,
};
const HealthInfo = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openAll, setOpenAll] = useState(false);
  const [openStates, setOpenStates] = useState(objFalse);
  const { loginInfo } = useSelector((state) => state.commonApp);
  const { questionsCompleteCheck } = useSelector((state) => state.others);
  const myinfo = useSelector((state) => state.others.userInfo?.user);
  const { sendSingleEvent } = useGAEvent();
  const handleToggle = (id, name) => {
    sendSingleEvent({
      event: "healthinfo_detail",
      label: "healthinfo_button_name",
      value: name,
    });
    // console.log(id, name);
    setOpenStates((prev) => ({ ...prev, [id]: !openStates[id] }));
  };

  useEffect(() => {
    dispatch(checkQuestionsComplete(loginInfo.userId))
      .unwrap()
      .then((res) => {
        if (res.ok) {
          if (!res.healthComplete) {
            navigate(`/question/health`, { replace: true });
          } else {
            dispatch(fetchMyinfo(loginInfo.userId));
          }
        }
      })
      .catch((err) => console.log(err));
  }, [dispatch, loginInfo.userId, navigate]);

  useEffect(() => {
    if (Object.values(openStates).every((value) => value === true)) {
      setOpenAll(true);
    } else setOpenAll(false);
  }, [openStates, openAll]);

  const closedComponent = ({ color, id, title }) => (
    <div
      className={`flex items-center justify-between rounded-lg px-6 py-5 ${color} `}
      onClick={() => {
        handleToggle(id, title);
      }}
    >
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <div className="flex-shrink-0">
          <TitleBox option={1} title={title} />
        </div>
        {title === "Physical & Medical Info" || title === "Dietary Habits" ? (
          <div className="px-3 py-1 text-base font-bold bg-white rounded-lg text-gray_140 flex-shrink-0">
            Edit
          </div>
        ) : null}
      </div>
      <img alt={"arrowRight"} src="/images/mobile/icon/arrow_right.svg" className="flex-shrink-0" />
    </div>
  );
  return (
    <>
      <HeadCont rightIcon={"no icon"} transparent={"white"} />
      {questionsCompleteCheck &&
      questionsCompleteCheck.healthComplete &&
      myinfo ? (
        <section className="mx-6 mb-6 safe-area-mt-header">
          <TitleBox option={5} title={`${myinfo.nickName}'s<br />Health Profile`} />
          {/* <div className="flex items-center justify-end mb-11"> */}
          <div className="mb-2.5 flex items-center justify-end">
            <span className="text-caption2_400 text-gray_120">
              Updated: {dayjs().format("YYYY-MM-DD (HH:mm)")}
            </span>
          </div>
          <div
            onClick={() => {
              sendSingleEvent({
                event: "healthinfo_detail",
                label: "healthinfo_button_name",
                value: "Expand All",
              });
              if (Object.values(openStates).every((value) => value === true)) {
                setOpenStates(objFalse);
                setOpenAll(false);
              } else {
                setOpenStates(objTrue);
                setOpenAll(true);
              }
            }}
            className="mb-1.5 flex items-center justify-end gap-1.5"
          >
            <span
              className={`text-caption2_700 ${
                openAll ? "text-gray_120" : "text-gray_170"
              } `}
            >
              {openAll ? "Collapse All" : "Expand All"}
            </span>
            {openAll ? (
              <img
                alt="openAll"
                src="/images/mobile/icon/checkbox_thick_gray.svg"
              />
            ) : (
              <img
                alt="openAll"
                src="/images/mobile/icon/checkbox_thick_dark.svg"
              />
            )}
          </div>

          <div className="break-words">
            <div className="mb-3 mt-4">
              <AnimateCard
                id={0}
                openStates={openStates}
                closedComponent={closedComponent({
                  color: "bg-orange_10",
                  id: 0,
                  title: "Weight Management Guide",
                })}
                contentComponent={
                  <BodyMassCard
                    myinfo={myinfo}
                    loginInfo={loginInfo}
                    handleToggle={() => handleToggle(0, "Weight Management Guide")}
                  />
                }
              />
            </div>
            <div className="mb-3">
              <AnimateCard
                id={1}
                openStates={openStates}
                closedComponent={closedComponent({
                  color: "bg-orange_10",
                  id: 1,
                  title: "Nutrition Goals",
                })}
                contentComponent={
                  <NutritionCard
                    myinfo={myinfo}
                    handleToggle={() => handleToggle(1, "Nutrition Goals")}
                  />
                }
              />
            </div>
            {/* <GuideCard myinfo={myinfo} /> */}
            <div className="mb-3">
              <AnimateCard
                id={2}
                openStates={openStates}
                closedComponent={closedComponent({
                  color: "bg-orange_10",
                  id: 2,
                  title: "Foods to Limit",
                })}
                contentComponent={
                  <CautionFood
                    myinfo={myinfo}
                    handleToggle={() => handleToggle(2, "Foods to Limit")}
                  />
                }
              />
            </div>
            {/* <IntakeCard /> */}
            <div className="mb-3 mt-5">
              <AnimateCard
                id={3}
                openStates={openStates}
                closedComponent={closedComponent({
                  color: "bg-green_10",
                  id: 3,
                  title: "Physical & Medical Info",
                })}
                contentComponent={
                  <BodyInfoCard
                    myinfo={myinfo}
                    handleToggle={() => handleToggle(3, "Physical & Medical Info")}
                  />
                }
              />
            </div>
            {/*기존 입력폼 대신 링크로 처리(신체정보, 질병정보일부 합침) */}
            <div className="mb-3">
              <AnimateCard
                id={4}
                openStates={openStates}
                closedComponent={closedComponent({
                  color: "bg-yellow_10 ",
                  id: 4,
                  title: "Dietary Habits",
                })}
                contentComponent={
                  <FoodLifeCard
                    userDietLife={myinfo?.userDietLife}
                    handleToggle={() => handleToggle(4, "Dietary Habits")}
                  />
                }
              />
            </div>
          </div>
        </section>
      ) : (
        ""
      )}
      <span className="h-[115px]"></span>
      <MenuBar />
    </>
  );
};

export default HealthInfo;
